import { BaseError } from 'make-error-cause';

export default class EDFError extends BaseError {
    name: string;
    code: string;

    constructor(message: string, code?: string, cause?: Error) {
        super(message, cause);
        this.name = this.constructor.name;
        this.code = code || 'EDF:Error';
    }

    toJSON(): { name: string; message: string; code: string } {
        return { name: this.name, message: this.message, code: this.code };
    }
}
